export default __webpack_public_path__ + "static/media/page-flip-01a.35bca9c7.mp3";